import React from 'react';
import { Card } from 'antd';

const ResourceCard = ({ title, icon, children, extra }) => {
  return (
    <Card
      title={
        <span>
          {icon && <span style={{ marginRight: 8 }}>{icon}</span>}
          {title}
        </span>
      }
      extra={extra}
      style={{ marginBottom: 16 }}
      bordered={false}
    >
      {children}
    </Card>
  );
};

export default ResourceCard;
